import { getGlAccountWithBalance } from "@/services/gl.service";
import { useQuery } from "@tanstack/react-query";

export const useGlAccountWithBalance = (glId, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["gl-account-with-balance", glId],
    queryFn: () => getGlAccountWithBalance({ glId }),
    enabled: enabled && !!glId,
    ...options,
  });
};
